// extracted by mini-css-extract-plugin
var _1 = "vDvI8ZP0f2e9vxxKFOrM";
var _2 = "O_BGVPfXX9sy7CPH2UX3";
export { _1 as "spin", _2 as "spinner" }
